import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Divider,
} from '@mui/material';

const TermsOfService = ({ open, onClose }) => {
  const currentDate = new Date().toLocaleDateString('en-US', { 
    year: 'numeric', 
    month: 'long', 
    day: 'numeric' 
  });

  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          maxHeight: '90vh',
        }
      }}
    >
      <DialogTitle>
        <Typography variant="h5" component="h2" sx={{ fontWeight: 600 }}>
          Terms of Service
        </Typography>
        <Typography variant="caption" color="text.secondary">
          Effective Date: {currentDate}
        </Typography>
      </DialogTitle>
      <DialogContent dividers>
        <Box sx={{ py: 2 }}>
          <Typography variant="body2" paragraph sx={{ whiteSpace: 'pre-line', lineHeight: 1.8 }}>
            <strong>1. Acceptance of Terms</strong>{'\n'}
            By accessing or using Vendoroll ("the Platform"), you agree to be bound by these Terms of Service. If you do not agree, do not use the Platform.
          </Typography>

          <Divider sx={{ my: 2 }} />

          <Typography variant="body2" paragraph sx={{ whiteSpace: 'pre-line', lineHeight: 1.8 }}>
            <strong>2. Description of Service</strong>{'\n'}
            Vendoroll is a platform that connects vendors with markets and event organizers for the purpose of discovery and application management. Vendoroll does not process payments or handle financial transactions between vendors and organizers.
          </Typography>

          <Divider sx={{ my: 2 }} />

          <Typography variant="body2" paragraph sx={{ whiteSpace: 'pre-line', lineHeight: 1.8 }}>
            <strong>3. User Responsibilities</strong>{'\n'}
            • You must provide accurate and complete information.{'\n'}
            • You agree not to use the Platform for unlawful or unauthorized purposes.{'\n'}
            • You are responsible for your interactions with other users.
          </Typography>

          <Divider sx={{ my: 2 }} />

          <Typography variant="body2" paragraph sx={{ whiteSpace: 'pre-line', lineHeight: 1.8 }}>
            <strong>4. Account Termination</strong>{'\n'}
            Vendoroll may suspend or terminate accounts at any time for violations of these Terms, illegal activity, or misuse of the Platform.
          </Typography>

          <Divider sx={{ my: 2 }} />

          <Typography variant="body2" paragraph sx={{ whiteSpace: 'pre-line', lineHeight: 1.8 }}>
            <strong>5. Intellectual Property</strong>{'\n'}
            All content, design, and software of Vendoroll are owned by Vendoroll. Users retain ownership of their own content (e.g., vendor profiles, applications).
          </Typography>

          <Divider sx={{ my: 2 }} />

          <Typography variant="body2" paragraph sx={{ whiteSpace: 'pre-line', lineHeight: 1.8 }}>
            <strong>6. Disclaimer of Warranties</strong>{'\n'}
            The Platform is provided "as is" without warranties of any kind. Vendoroll does not guarantee the accuracy, reliability, or suitability of any content, vendor, or organizer.
          </Typography>

          <Divider sx={{ my: 2 }} />

          <Typography variant="body2" paragraph sx={{ whiteSpace: 'pre-line', lineHeight: 1.8 }}>
            <strong>7. Limitation of Liability</strong>{'\n'}
            Vendoroll is not liable for damages arising from your use of the Platform, including disputes between vendors and organizers.
          </Typography>

          <Divider sx={{ my: 2 }} />

          <Typography variant="body2" paragraph sx={{ whiteSpace: 'pre-line', lineHeight: 1.8 }}>
            <strong>8. Governing Law</strong>{'\n'}
            These Terms are governed by the laws of Alberta, Canada.
          </Typography>

          <Divider sx={{ my: 2 }} />

          <Typography variant="body2" paragraph sx={{ whiteSpace: 'pre-line', lineHeight: 1.8 }}>
            <strong>9. Contact</strong>{'\n'}
            Questions about these Terms? Contact us at{' '}
            <Typography 
              component="a" 
              href="mailto:info@vendoroll.com" 
              sx={{ color: 'primary.main', textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}
            >
              info@vendoroll.com
            </Typography>.
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained" color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TermsOfService;

